function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M563.878-656.008c6.314,0,11.756,4.852,12.014,10.812a11.23,11.23,0,0,1-9.62,11.683c-3.84.554-5.178,3.342-6.284,5.342-1.116-2-2.462-4.784-6.31-5.34a11.264,11.264,0,0,1-9.668-11.679c.264-6.162,5.846-10.81,12.982-10.81H564m.074-4h-7.082c-9.368,0-16.62,6.342-16.977,14.637a15.3,15.3,0,0,0,13.1,15.811,3.49,3.49,0,0,1,2.524,1.776L560-620l4.364-7.774a3.5,3.5,0,0,1,2.526-1.778,15.3,15.3,0,0,0,13.1-15.811c-.358-8.3-7.61-14.637-15.912-14.637Z",
  transform: "translate(-540 660)"
});

var SvgIconSpeak = function SvgIconSpeak(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSpeak, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-speak.4884bd5f.svg";
export { ForwardRef as ReactComponent };